import api from "./api";

// GET all properties
export const getAllProperties = async () => {
    try {
        const response = await api.get("/api/properties/v2");
        return response.data;
    } catch (error) {
        throw error;
    }
};

// GET a property by ID
export const getPropertyById = async (id) => {
    try {
        const response = await api.get(`/api/properties/v2/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// POST (Create) a new property
export const createProperty = async (formData) => {
    try {
        const response = await api.post("/api/properties/v2", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// PUT (Update) a property by ID
export const updateProperty = async (id, data) => {
    try {
        const response = await api.put(`/api/properties/v1/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// DELETE a property by ID
export const deleteProperty = async (id) => {
    try {
        const response = await api.delete(`/api/properties/v1/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// 🔍 SEARCH properties based on filters
export const searchProperties = async (searchData) => {
    try {
        const response = await api.post("/api/properties/v2/searchresult/bycustomsearch", searchData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};




export const addInterestedUser = async (propertyId, userId) => {
    try {
        const response = await api.post(`/api/properties/v2/${propertyId}/interested`, { userId });
        return response.data;
    } catch (error) {
        return error?.response;
    }
};




export const getPropertyByCity = async (city) => {
    try {
        const response = await api.get(`/api/properties/v2/location/by-city?city=${"Jaipur"}`);
        return response?.data?.properties;
    } catch (error) {
        throw error;
    }
};